export var AUTO_SCROLL_TO_LAST_ACTIVE = true;
export var ALLOW_ONLY_ONE_OPENED = false;
export var SIZE = 'XS';
export var TEST_ID = 'accordion';